import React from "react";
import FileViewer from "react-file-viewer";
//@ts-ignore
import { tw } from "@careinfo/tailwind";

type Props = {
  fileType: string;
  filePath: string;
};

const CustomFileViewer: React.FC<Props> = ({ fileType, filePath }) => {
  const onError = (e: any) => {
    console.error("Error loading file:", e);
  };

  const imageTypes = ["jpg", "jpeg", "png", "gif", "webp"];

  if (imageTypes.includes(fileType)) {
    return (
      <div
        className={tw`w-full h-32 p-2 rounded-md flex items-center justify-center overflow-hidden`}
      >
        <img
          src={filePath}
          alt="preview"
          className={tw`object-cover h-full w-full rounded`}
          onError={(e) => console.error("Image load error:", e)}
        />
      </div>
    );
  }

  return (
    <div
      className={tw`w-full h-32 p-2  rounded-md flex items-center justify-center overflow-hidden`}
    >
      <div className={tw`w-full h-full `}>
        <FileViewer fileType={fileType} filePath={filePath} onError={onError} />
      </div>
    </div>
  );
};

export default CustomFileViewer;
